// 搜索项
export const searchSource = [
  {
    title: "组合处理编号",
    key: "assembleNo",
    template: "input",
    placeholder: "请输入组合处理编号",
  },
  {
    title: "组合状态",
    key: "status",
    template: "select",
    placeholder: "请选择组合状态",
    selectList: [
      {
        name: "未组合",
        value: "uncombined",
      },
      {
        name: "组合中",
        value: "inCombination",
      },
      {
        name: "组合完成",
        value: "combined",
      },
      {
        name: "取消组合",
        value: "cancelCombination",
      },
    ],
  },
  {
    title: "组合状态",
    key: "status1",
    template: "select",
    multiple: true,
    placeholder: "请选择组合状态",
    selectList: [
      {
        name: "未组合",
        value: "uncombined",
      },
      {
        name: "组合中",
        value: "inCombination",
      },
      {
        name: "组合完成",
        value: "combined",
      },
      {
        name: "取消组合",
        value: "cancelCombination",
      },
    ],
  },
  {
    title: "日期筛选",
    key: "date",
    template: "date-picker",
    type: "daterange",
  },
];

// 父表格 title
export const listColumns = [
  {
    title: "组合处理编号",
    dataIndex: "id",
    key: "id",
    width: 120,
  },
  {
    title: "商品图片",
    dataIndex: "productImg",
    key: "productImg",
    width: 120,
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品sku",
    dataIndex: "productSku",
    key: "productSku",
  },
  {
    title: "规格",
    dataIndex: "specifications",
    key: "specifications",
  },
  {
    title: "已组合/组合数量",
    dataIndex: "assembledNum",
    key: "assembledNum",
  },
  {
    title: "成品数量",
    dataIndex: "productsNum",
    key: "productsNum",
  },
  {
    title: "组合状态",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "operation",
    scopedSlots: {
      customRender: "operation",
    },
  },
];

// 展开子表格 title
export const productColumns = [
  {
    id: 1,
    label: "图片",
    key: "productImg",
  },
  {
    id: 2,
    label: "商品名称",
    key: "productName",
  },
  {
    id: 3,
    label: "商品sku",
    key: "productSku",
  },
  {
    id: 4,
    label: "规格",
    key: "specifications",
  },
  {
    id: 5,
    label: "质检上架数",
    key: "qualityNum",
  },
  {
    id: 6,
    label: "单组数量",
    key: "singleNum",
  },
];
